import { type Plugin } from "@nuxt/types";

import Snowplow from "@/utils/snowplow";

const plugin: Plugin = (context, inject) => {
  const snowplow = new Snowplow(context);

  inject("snowplow", snowplow);
  context.$snowplow = snowplow;
};

export default plugin;
